export default "__VITE_ASSET__BHZ6Kxsx__"